import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';

import { Login } from 'pages/Login';
import { Users } from 'pages/Users';
import { UserDetail } from 'pages/UserDetail';
import { ProtectedRoute } from 'uiComponents/ProtectedRoute';

export const Routes = () => (
    <RouterRoutes>
        <Route
            path='/login'
            element={<Login />}
        />

        <Route
            path='/'
            element={
                <ProtectedRoute>
                    <Users />
                </ProtectedRoute>
            }
        />

        <Route
            path='/users/:id'
            element={
                <ProtectedRoute>
                    <UserDetail />
                </ProtectedRoute>
            }
        />

        <Route
            path='*'
            element={
                <Navigate
                    to='/'
                    replace
                />
            }
        />
    </RouterRoutes>
);
